export function isTimeunitGovernance(name: string) {
  return name === 'Governor Anastasius'
}
